import CategoryBadge from "../common/CategoryBadge";
import type { Article } from "../../types/article";

type Props = {
    articles: Article[];
};

export default function TopStoriesRow({ articles }: Props) {
    return (
        <section className="overflow-x-auto pb-2">
            <div className="flex min-w-max gap-5">
                {articles.map((article) => (
                    <article
                        key={article.id}
                        className="w-[320px] overflow-hidden rounded-2xl border border-white/10 bg-[#0d121b]"
                    >
                        <div className="h-[180px]">
                            <img
                                src={article.image}
                                alt={article.title}
                                className="h-full w-full object-cover"
                            />
                        </div>

                        <div className="space-y-3 p-4">
                            <CategoryBadge label={article.category} />
                            <h3 className="line-clamp-2 text-lg font-black uppercase leading-tight text-white">
                                {article.title}
                            </h3>
                            <p className="line-clamp-2 text-sm text-white/65">
                                {article.excerpt}
                            </p>
                        </div>
                    </article>
                ))}
            </div>
        </section>
    );
}